import { jsx as _jsx } from "react/jsx-runtime";
import * as S from "./viewportMenu.styles";
export function ViewportMenu({ items, onChange, selection, }) {
    return (_jsx(S.Menu, { children: items.map((item) => {
            return (_jsx(S.Item, { "$isSelected": item.key === selection, onClick: () => {
                    if (item.key !== selection) {
                        onChange(item.key);
                    }
                }, children: typeof item.icon === "string" ? (_jsx(S.ItemImage, { src: item.icon })) : (_jsx(item.icon, {})) }, item.key));
        }) }));
}
